<template>
  <div class="itemInner" :class="{hiddenPrice: hiddenPrice}">
    <!-- 공용디바이스에서 넘어온 개인디바이스인 경우 사이트정보가 아닌 결제확인용으로만 사용하므로 페이지 or 상품 링크가 걸려선 안됨 -->
    <div v-if="noLink" class="itemInfo" :class="{isEmpty: isEmpty(item.info.subject[lang])}">
      <div v-if="item.info.thumbnail && item.info.thumbnail !== ''" class="thumb">
        <img :src="item.info.thumbnail" alt="">
      </div>
    </div>
    <div v-else-if="item.submitId.includes('system_amenity')" class="itemInfo notranslate toCapitalize">
      <router-link :to="{name: 'amenity'}">
        <div class="subject">
          {{locale.amenity}}
        </div>
      </router-link>
    </div>
    <!-- 이외 사이트 내에서 주문내역 등에서는 페이지 or 상품 링크가 필요함 -->
    <div v-else class="itemInfo" :class="{isEmpty: isEmpty(item.info.subject[lang])}">
      <router-link
        v-if="itemInfo.isPage || itemInfo.isProduct"
        :to="{
          name: itemInfo.routeName,
          params: {
            ...itemInfo.routeParams,
            lang: lang
          }
        }"
        class="itemInfo">
        <div v-if="item.info.thumbnail && item.info.thumbnail !== ''" class="thumb">
          <img :src="item.info.thumbnail" alt="">
        </div>
        <div class="subject">
          {{item.info.subject[lang]}}
          <p v-if="item.place" class="place">({{locale.place}}: {{item.place[lang]}})</p>
        </div>
      </router-link>
    </div>
    <div class="itemOption">
      <!-- options -->
      <div v-if="options.length &&  options.filter(x => x.value).length" class="optionInfo">
        <div class="list">
          <div
            v-for="(order, index) in options.filter(x => x.value && (x.type === 'checkbox' ? x.value.length : `${x.value}`.length))"
            :key="index"
            :class="{isSubOption: order.isSubOption}">
            <div v-if="order.type === 'checkbox'" class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
              <span class="label">{{order.label ? order.label[lang] : '-'}}</span>
              <div class="value">
                <span
                  v-for="(option, index) in displayValue(order)"
                  :key="index"
                  class="valueArr">
                  {{option}}
                </span>
              </div>
            </div>
            <div v-else class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
              <span v-if="isTip" class="label">{{locale.tip}}</span>
              <span v-else-if="isAmenity" class="label">
                <img :src="amenityThumb(order)" class="ico" alt="">
                {{amenityName(order)}}
              </span>
              <span v-else class="label">{{order.label[lang]}}</span>
              <div v-if="isTip" class="value priceDpBoard">
                {{priceFormat(order.price)}}
              </div>
              <div v-else-if="order.type === 'cert'">
                <div class="value notranslate">
                  <div>{{locale.name}}: {{order.value.name}}</div>
                  <div>{{locale.telephone}}: {{order.value.phone}}</div>
                  <div>{{locale.birthdate}}: {{order.value.birthDate}}</div>
                </div>
              </div>
              <div v-else-if="order.type === 'uploadImage'" class="notranslate">
                <div v-for="img in order.value"
                  :key="img.id">
                  <span v-if="img.previewType === 'filename'">🖺 {{img.name}}</span>
                  <img v-else :src="img.path" class="mt5" alt="">
                </div>
              </div>
              <div v-else class="value"
                :class="{notranslate: order.type === 'rate'}">
                <img v-if="order.type === 'signaturepad'" :src="order.value" alt="">
                <span v-else>{{displayValue(order)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //options -->
      <!-- datetime -->
      <div v-if="itemDatetime" class="setDatetime row notranslate">
        <span class="label">{{itemDatetime.datetimeOnly === 'date'
          ? locale.date
          : itemDatetime.datetimeOnly === 'time'
            ? locale.time
            : locale.datetime}}</span>
        <span class="value">{{requestTime}}</span>
      </div>
      <!-- //datetime -->
      <!-- coupon -->
      <div v-if="item.useCoupon && item.useCoupon.useCoupon" class="optionInfo">
        <div class="list">
          <div v-for="(coupon, index) in item.useCoupon.useCoupon"
            :key="index"
            class="item"
            :class="{interSection: couponIntersection(coupon.cid)}">
            <div>
              <div class="label">
                ({{locale.coupon}}) {{coupon.payload.text1[lang] || coupon.payload.text2[lang] || coupon.title}}
                <span v-if="couponIntersection(coupon.cid)" class="priceDpBoard">
                  ({{getCouponValue(coupon.payload)}} * {{couponIntersection(coupon.cid).qty}})
                </span>
              </div>
              <div class="value notranslate priceDpBoard">
                <span v-if="couponIntersection(coupon.cid)">
                  {{getCouponValue(coupon.payload, couponIntersection(coupon.cid).qty)}}
                </span>
                <span v-else>
                  {{getCouponValue(coupon.payload)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //coupon -->
      <!-- price -->
      <div v-if="item.price" class="priceInfo notranslate priceDpBoard">
        <div class="byQuantity row">
          <div v-if="!isTip && item.price.info && item.price.info.price && item.price.info.price > 0" class="item priceDpBoard">
            <span class="label toCapitalize">{{locale.summary_unitprice}}</span>
            <span class="value">{{priceFormat(item.price.info.price)}}</span>
          </div>
          <div v-if="!isTip && priceOption.length" class="priceDpBoard">
            <div class="item"
              v-for="(info, index) in priceOption"
              :key="index">
              <div class="label toCapitalize">
                <span v-if="!isAmenity">[{{locale.option_price}}]</span>
                {{!isAmenity ? info.label : amenityName(info)}}
                <span v-if="info.quantity">({{info.quantity}})</span>
              </div>
              <div class="value">{{priceFormat(info.price)}}</div>
            </div>
          </div>
          <div v-if="!isTip && itemQuantity" class="item">
            <span class="label toCapitalize">{{locale.quantity}}</span>
            <span class="value">{{item.price.info.quantity}}</span>
          </div>
          <!-- 고객식별타입 -->
          <div v-if="item.guestTypePrice && isGuestDiscount" class="item priceDpBoard">
            <div class="label toCapitalize">
              {{item.guestTypePrice.name[lang]}}<span v-if="item.guestTypePrice.discountPrice"> ({{item.guestTypePrice.priceDiscount}})</span>
            </div>
            <div class="value">{{priceFormat(item.guestTypePrice.discountPrice) || item.guestTypePrice.priceDiscount}}</div>
          </div>
          <!-- //고객식별타입 -->
          <!-- discount -->
          <div v-if="item.price.info && item.price.info.discount" class="item priceDpBoard">
            <span class="label">{{locale.discount}}</span>
            <span class="value">-{{priceFormat(item.price.info.discount)}}</span>
          </div>
          <!-- //discount -->
          <div v-if="item.price.info && item.price.info.total !== 0" class="item price priceDpBoard">
            <div class="label toCapitalize">{{locale.total}}</div>
            <div class="value">
              <span v-if="item.guestTypePrice && item.guestTypePrice.normalPrice" class="normalPrice">{{priceFormat(item.guestTypePrice.normalPrice)}}</span>
              {{priceFormat(itemPrice(item.price.info))}}
            </div>
          </div>
        </div>
      </div>
      <!-- //price -->
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'

export default {
  name: 'OrderItem',
  props: [
    'itemData',
    'lang',
    'locale',
    'localeAmenity',
    'noLink',
    'isTip'
  ],
  computed: {
    isAmenity () {
      return this.item.submitId.includes('system_amenity')
    },
    item () {
      const item = this.itemData
      return {
        ...item,
        content: item.content ? item.content.map(x => {
          return {
            ...x,
            value: x.valueOption || x.value
          }
        }) : []
      }
    },
    itemInfo () {
      const isPage = !!this.item.pageId && this.item.pageId !== null
      const isProduct = !!this.item.productId && this.item.productId !== null
      return {
        isPage: isPage,
        isProduct: isProduct,
        routeName: isPage ? 'page' : isProduct ? 'product' : null,
        routeParams: {
          ...isPage && {
            id: this.item.pageId
          },
          ...isProduct && {
            productId: this.item.productId
          }
        }
      }
    },
    options () {
      const isAmenity = this.isAmenity
      return this.item.content
        ? this.item.content.filter(x => x.type !== 'quantity' && x.type !== 'datetime').map(x => {
          return {
            label: !isAmenity ? x.displayLabel : x.label || x.item,
            type: !isAmenity ? x.type : x.item,
            value: !isAmenity ? x.valueOption || x.value : x.value || x.count,
            isSubOption: !isAmenity ? x.isSubOption : false,
            optionDepth: !isAmenity ? x.optionDepth : 0,
            ...x.price && {
              price: x.price
            }
          }
        }) : []
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm:ss'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    requestTime () {
      const settime = this.itemDatetime ? DateTime.fromISO(this.itemDatetime.settime, { zone: this.timezone }) : null
      const requestTime = settime
        ? this.itemDatetime.type === 'asap'
          ? this.locale.datetime_asap
          : this.itemDatetime.datetimeOnly === 'date'
            ? settime.toFormat(this.dateFormat)
            : this.itemDatetime.datetimeOnly === 'time'
              ? settime.toFormat('HH:mm')
              : settime.toFormat(this.format)
        : null
      return requestTime
    },
    itemDatetime () {
      const datetime = this.item.content && this.item.content.find(x => x.type === 'datetime')
      return datetime ? datetime.value : null
    },
    itemQuantity () {
      const quantity = this.item.price && this.item.price.info && this.item.price.info.quantity
      return quantity || null
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    priceOption () {
      const lang = this.lang
      let option = []
      const isAmenity = this.item.submitId.includes('system_amenity')
      this.item.content.forEach(function (x) {
        if (x.value && x.type !== 'quantity') {
          if (x.type === 'checkbox') {
            option = option.concat(x.value.filter(o => o.price && o.price.length).map(function (oo) {
              return {
                label: oo.label ? oo.label[lang] : '',
                price: oo.quantity ? Number(oo.price) * Number(oo.quantity) : Number(oo.price),
                ...oo.quantity && {
                  quantity: Number(oo.quantity)
                }
              }
            }))
          } else if (x.value.price) {
            option = option.concat({
              label: x.value.label ? x.value.label[lang] : '',
              price: x.value.quantity ? Number(x.value.price) * Number(x.value.quantity) : Number(x.value.price),
              ...x.value.quantity && {
                quantity: Number(x.value.quantity)
              }
            })
          } else if (isAmenity && x.price) { // amenity v2
            option = option.concat({
              label: x.label,
              type: x.item,
              price: Number(x.price) * Number(x.value),
              quantity: x.value
            })
          }
        }
      })
      return option
    },
    isGuestDiscount () {
      return this.itemData.guestTypePrice && this.itemData.guestTypePrice.normalPrice !== this.itemData.guestTypePrice.total
    },
    hiddenPrice () {
      return this.item.hiddenPrice
    }
  },
  data () {
    return {
    }
  },
  methods: {
    datetimeFormat (iso) {
      DateTime.fromISO(iso, { zone: this.timezone })
    },
    displayValue (order) {
      const lang = this.lang
      let value = order.value
      switch (order.type) {
        case 'rate':
          value = `${value.value} / ${value.max}`
          break
        case 'radio':
          value = value.label[lang] + (value.quantity ? ` (${value.quantity})` : '')
          break
        case 'checkbox':
          value = value.map(x => {
            const label = x.label[lang]
            const quantity = x.quantity ? `(${x.quantity})` : ''
            return `${label} ${quantity}`
          })
          break
        case 'select':
          value = value.label ? value.label[lang] : value
          break
        case 'calendar':
          value = DateTime.fromISO(value).toFormat(this.dateFormat)
          break
      }
      return value
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    isEmpty (str) {
      return regExp.replaceAllEmpty(str).length <= 0
    },
    itemPrice (price) {
      return price.tax && price.subtotal ? price.subtotal : price.total
    },
    amenityThumb (order) {
      const image = `${order.type.toLowerCase()}.png`
      return require(`@/assets/img/amenity/${image}`)
    },
    amenityName (order) {
      const lang = this.$route.params.ln
      const code = order.type.toLowerCase()
      return order.label && typeof (order.label) === 'object'
        ? order.label[lang]
        : this.localeAmenity[`amenity_${code}`]
    },
    getCouponValue (coupon, qty) {
      let result = ''
      function discountRate (total, rate) { // 할인율 적용된 금액
        const totalPrice = total && parseFloat(total) > 0
        return totalPrice ? parseFloat(total) * parseFloat(rate) / 100 : null
      }
      if (coupon && coupon.discount) {
        const discountType = coupon.discountType
        const value = coupon.discountValue
        const total = this.item.useCoupon && this.item.useCoupon.couponPrice && this.item.useCoupon.couponPrice.normalPrice
        switch (discountType) {
          case 'price':
            result = this.priceFormat(value * (qty ? parseInt(qty) : 1))
            break
          case 'rate':
            result = discountRate(total, value)
              ? `${this.priceFormat(discountRate(total, value))}` // ${value}%
              : ''
            break
        }
        result = `-${result}`
      }
      return result
    },
    couponIntersection (cid) {
      const coupon = this.item.useCoupon && this.item.useCoupon.useCoupon && this.item.useCoupon.useCoupon.filter(x => x.cid === cid && x.payload.allowedQty)
      return coupon && coupon.length ? {
        qty: coupon.length,
        ...coupon[0].payload.discount && coupon[0].payload.discountValue && {
          discountValue: parseInt(coupon[0].payload.discountValue) * coupon.length
        }
      } : null
    }
  }
}
</script>

<style lang="scss" scoped>
.valueArr {
  display: block;
}
.normalPrice {
  margin-right: 10px;
  font-weight: normal;
  font-size: 0.85em;
  text-decoration: line-through;
  color: $color-grey;
}
</style>
